import { createFileRoute } from '@tanstack/react-router';
import { PersonDetailRoute } from '../../../screens/People';

export const Route = createFileRoute('/tasks/people/$id')({
  component: PersonDetailRoute,
});
